// Shared framer-motion variants and helpers
export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.96 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const pageTransition = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, y: -16, transition: { duration: 0.3 } },
};

// Product image URLs (real user photography). Swap src here easily.
export const IMAGES = {
  systemDiagram:
    "https://customer-assets.emergentagent.com/job_989bc59f-c9c9-4c4e-97e4-d4aa4bdb3582/artifacts/tsvv7nfy_WhatsApp%20Image%202026-07-03%20at%2022.11.00.jpeg",
  growbot:
    "https://customer-assets.emergentagent.com/job_989bc59f-c9c9-4c4e-97e4-d4aa4bdb3582/artifacts/pqqhvepj_WhatsApp%20Image%202026-07-05%20at%2018.38.32.jpeg",
  multidoser:
    "https://customer-assets.emergentagent.com/job_989bc59f-c9c9-4c4e-97e4-d4aa4bdb3582/artifacts/vv0byoi6_WhatsApp%20Image%202026-07-05%20at%2018.39.00.jpeg",
  vacuumDryer:
    "https://customer-assets.emergentagent.com/job_989bc59f-c9c9-4c4e-97e4-d4aa4bdb3582/artifacts/tmakip1y_WhatsApp%20Image%202026-07-05%20at%2018.36.49.jpeg",
  diyKit:
    "https://customer-assets.emergentagent.com/job_989bc59f-c9c9-4c4e-97e4-d4aa4bdb3582/artifacts/5eid3y5k_WhatsApp%20Image%202026-07-05%20at%2018.38.06.jpeg",
  lab1:
    "https://images.unsplash.com/photo-1669101283516-e608dcf142df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG1vZGVybiUyMGJpb3RlY2glMjBsYWJvcmF0b3J5fGVufDB8fHx8MTc4NDA2MDc3Mnww&ixlib=rb-4.1.0&q=85",
  lab2:
    "https://images.unsplash.com/photo-1616996691748-3f5f78093ab0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMG1vZGVybiUyMGJpb3RlY2glMjBsYWJvcmF0b3J5fGVufDB8fHx8MTc4NDA2MDc3Mnww&ixlib=rb-4.1.0&q=85",
  nature:
    "https://images.unsplash.com/photo-1457530378978-8bac673b8062?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwZ3JlZW4lMjBuYXR1cmUlMjBwbGFudCUyMGdyb3dpbmd8ZW58MHx8fHwxNzg0MDYwNzczfDA&ixlib=rb-4.1.0&q=85",
};
